<template>
  <div id="MyWithdraw">
    <div class="centerContent">
      <div class="leftContent">
        <div class="topTitle">入金</div>
        <div class="textWrap">
          <div class="bankDetails" v-if="!isHxBank">
            <div class="bankDetailsWrap">
              <div class="desc">
                <span class="title">收款方户名</span>
                <el-input v-model="bankDetails.payeeName" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.payeeName"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
              <div class="desc">
                <span class="title">收款方账号</span>
                <el-input v-model="bankDetails.payeeCode" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.payeeCode"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
              <div class="desc">
                <span class="title">收款方开户行</span>
                <el-input v-model="bankDetails.payeeBankName" disabled />
                <div class="btnWrap">
                  <p
                    v-clipboard:copy="bankDetails.payeeBankName"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    aria-hidden="true"
                    class="iconCopy"
                  >复制</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-else class="bankDetails">
            <div class="bankDetailsWrap">
              <div class="desc">
                <span class="title">入金金额</span>
                <el-input v-model="totalAmount" placeholder="请输入入金金额" type="number" @input="changeAmount" @keydown.native="channelInputLimit">
                </el-input>
                <div class="btnWrap"></div>
              </div>
              <div class="desc">
                <span class="title">资金密码</span>
                <el-input
                  v-model="widthPwd"
                  :type="passInType"
                  auto-complete="new-password"
                  placeholder="请输入资金密码"
                >
                  <template slot="suffix">
                    <img
                      class="eyeStyle"
                      :src="passwordInIcon"
                      alt=""
                      @click="changeInType"
                    >
                  </template>
                </el-input>
                <div class="btnWrap">
                  <el-button
                    :loading="loading1"
                    :disabled="btnDisenable1"
                    type="primary"
                    @click="handleSubmitRj"
                  ><span style="color: #fff">提交</span></el-button>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="rightContent">
        <div class="topTitle">
          <span>出金</span>
          <span class="topBanlance">余额：{{ myAccount.balance | toThousands }}</span>
        </div>
        <div class="textWrap">
          <div class="bankDetails">
            <div class="bankDetailsWrap">
              <div class="desc">
                <span class="tip">
                  初始资金密码：123456
                  <span v-if="APP_WINNY_NAME === '茗贵e购' || APP_WINNY_NAME === '神农购销' || APP_WINNY_NAME === '景瓷兴'" style="color: #7B94BD;cursor: pointer;" @click="openDetail">《出金手续费标准》</span>
                  <dialogWithId ref="dialog10"></dialogWithId>
                </span>
              </div>
              <div class="desc">
                <span class="title">出金金额</span>
                <el-input
                  v-model="ruleForm.amount"
                  :placeholder="'最大可出金额   ' + moreMagin"
                  type="number"
                  @input="changeWAmount"
                >
                  <template slot="suffix">
                    <span class="iconCopy" style="cursor: pointer;" @click="getAllMoney">全部</span>
                  </template>
                </el-input>
                <div class="btnWrap"></div>
              </div>
              <div class="desc">
                <span class="title">资金密码</span>
                <el-input
                  v-model="ruleForm.password"
                  :type="passType"
                  auto-complete="new-password"
                  placeholder="请输入资金密码"
                >
                  <template slot="suffix">
                    <img
                      class="eyeStyle"
                      :src="passwordIcon"
                      alt=""
                      @click="changeType"
                    >
                  </template>
                </el-input>
                <div class="btnWrap">
                  <el-button
                    :loading="loading"
                    :disabled="btnDisenable"
                    type="primary"
                    @click="handleSubmit"
                  ><span style="color: #fff">提交</span></el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 出入金流水 -->
    <div class="flow">
      <div class="headerWrap">
        <div class="leftText">出入金流水</div>
      </div>
      <div id="tablePage">
        <el-table
          ref="tableData"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%">
          <template slot="empty">
            <div class="no-datas">
              <div class="no-data-img">
                <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
              </div>
              <div class="no-data">暂无数据</div>
            </div>
          </template>
          <el-table-column align="center" prop="bizName" label="类型">
          </el-table-column>
          <el-table-column align="center" prop="amount" label="发生额">
          </el-table-column>
          <el-table-column prop="occurTime" label="时间" width="90">
            <template slot-scope="scope">
              {{ scope.row.occurTime | dateFormate }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="flowId" label="市场流水号">
          </el-table-column>
          <el-table-column align="center" prop="bankFlowId" label="银行流水号">
          </el-table-column>
        </el-table>
        <el-row v-if="pageData.total">
          <el-col :span="24" class="paginateWrap">
            <el-pagination
              popper-class="_popStyle"
              :current-page="pageData.currentPage"
              :page-sizes="pageData.pageSizes"
              :page-size="pageData.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
/*global http protocol protocolTrans */
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
import dialogWithId from '../../../components/base/dialog/dialogWithId.vue'
import protocol51 from './protocol51'
export default {
  components: {
    dialogWithId
  },
  data() {
    var checkAmount = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('出金金额不能为0，请重新输入'))
      } else if (value > this.moreMagin) {
        return callback(new Error('出金金额大于可出资金，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      totalAmount: null,
      widthPwd: null,
      loading: false,
      loading1: false,
      bankId: null,
      passType: 'password',
      passwordIcon: '',
      passInType: 'password',
      passwordInIcon: '',
      openImg: require('@/assets/images/icon/openeye.png'),
      closeImg: require('@/assets/images/icon/closeeye.png'),
      selectData: '',
      typeCode: null,
      tableData: [],
      pageData: {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      tableHeight: 0,
      /**户名：大连商品交易登记结算有限公司
        开户行：大连银行股份有限公司开发区支行
        行号：313222081290 */
      bankDetails: {
        bankNumber: "", // 行号
        payeeBankName: "", // 开户行
        payeeBranchBankName: "", // ?
        payeeCode: "", // 账号
        payeeName: "" // 户名
      },
      isWithdraw: false,
      /** 银行 */
      banks: [],
      /** 银行 end */
      ruleForm: {
        type: 'YH',
        id: '',
        name: '',
        bankId: '',
        amount: '',
        password: ''
      },
      btnDisenable: false,
      btnDisenable1: false,
      myAccount: {
        accountId: 0,
        avilibleMargin: 0,
        balance: 0,
        createTime: 0,
        currency: '人民币',
        enName: 'CNY',
        firmId: 0,
        frozenFunds: 0,
        lastBalance: 0,
        marketId: 28,
        marketName: '现货买进',
        marketType: '主市场',
        updateTime: 0,
        oweMoney: 0,
        outfundThreshold: 0,
        inGold: 0,
        marketInoutGold: 0
      },
      isHxBank: false,
      marketslastbalance: 0, // 三个市场的期初lastbalance之和
      marketsLastHoldPl: 0, // 三个市场的盈亏之和
      APP_WINNY_NAME: window.g.APP_WINNY_NAME
    }
  },
  computed: {
    ...mapGetters([
      'sessionInfoGetter',
      'myassetDataGetter',
      'h_sumClosePl',
      'marketStatusGetter',
      'holdPlSumGetter'
    ]),
    // 余额
    canwithdraw() {
      // var canOut = 0
      // if (Number(this.myAccount.marketInoutGold) < 0) {
      //   if (Math.abs(Number(this.myAccount.marketInoutGold)) > Number(this.myAccount.inGold)) {
      //     canOut = this.myAccount.balance - (this.myAccount.frozenFunds + this.myAccount.outfundThreshold + this.myAccount.inGold) + this.myAccount.inGold
      //   } else {
      //     canOut = this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.outfundThreshold - this.myAccount.inGold - this.myAccount.marketInoutGold
      //   }
      // } else {
      //   canOut = this.myAccount.balance - this.myAccount.frozenFunds - this.myAccount.outfundThreshold - this.myAccount.inGold
      // }
      // return canOut >= 0 ? canOut : 0

      // if (Number(this.myAccount.marketInoutGold) < 0) {
      //   return this.myAccount.balance - (this.myAccount.frozenFunds + this.myAccount.outfundThreshold + this.myAccount.inGold + this.myAccount.marketInoutGold)
      // }
      console.log('this.holdPlSumGetter ^_^', this.holdPlSumGetter.currentHoldPl, this.marketslastbalance)
      let canW = this.myAccount.balance - (this.myAccount.frozenFunds + this.myAccount.outfundThreshold + this.myAccount.inGold)
      console.log('canW ^_^', canW, this.marketslastbalance)
      if (canW > this.marketslastbalance) {
        canW = this.marketslastbalance
      }
      let pl = this.marketsLastHoldPl < 0 ? this.marketsLastHoldPl : 0 // 计算亏掉的浮亏部分
      console.log('pl ^_^', pl)
      if (canW > (Number(this.marketslastbalance) + Number(pl))) {
        canW = Number(this.marketslastbalance) + Number(pl)
      }
      if (canW < 0) {
        canW = 0
      }
      return canW.toFixed(2)
    },

    // 最大可出金额 最大可出金额的展示可出大于10000的时候-3，可出小于等于10000的时候-2(废弃)
    // 最新 5万以下每笔2元，5万(含)以上每笔4元 (先减去当日入金) inGold
    moreMagin() {
      // if (this.canwithdraw <= 50000) {
      //   return this.toZeroThousands(this.canwithdraw - 2)
      // } else {
      //   return this.toZeroThousands(this.canwithdraw - 4)
      // }
      return this.toZeroThousands(this.canwithdraw)
    }

  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = document.documentElement.clientHeight - this.$refs.tableData.$el.offsetTop - 32
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = document.documentElement.clientHeight - this.$refs.tableData.$el.offsetTop - 32
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.getSignInfo()
    setTimeout(() => {
      this.isClear = false
    }, 500)
    this.searchFirmId1()
    this.param_queryMyIntegralDetail()
    this.passwordIcon = this.closeImg
  },
  methods: {
    // 协议文本弹框
    openDetail() {
      this.$refs.dialog10.showDialog(10)
    },
    // 资金为负数默认展示0处理千分位
    toZeroThousands(num) {
      if (num && !isNaN(Number(num))) {
        var result = ''
        num = Number(num.toString() || 0).toFixed(2)
        var numAry = num.toString().split('.')
        var preNum = numAry[0]
        var lastNum = numAry[1]
        if (preNum.indexOf('-') !== -1) {
        // 存在-号
          return '0.00'
        } else {
          while (preNum.length > 3) {
            result = ',' + preNum.slice(-3) + result
            preNum = preNum.slice(0, preNum.length - 3)
          }
        }
        if (preNum) {
          result = preNum + result
        }
        result = result + '.' + lastNum
        return result
      } else {
      // // eslint-disable-next-line eqeqeq
      //   if (num == 0) {
        return '0.00'
        // } else {
        //   return num
        // }
      }
    },
    changeInType() {
      this.passInType = this.passInType == 'password' ? 'text' : 'password'
      this.passwordInIcon =
        this.passInType == 'password' ? this.closeImg : this.openImg
    },
    getSignInfo() {
      protocol51.param_findBankInfo.param.bankId = window.g.Bank_Id
      http.postFront(protocol51.param_findBankInfo).then((response) => {
        const { code, message, value } = response.data
        if (Number(code) === 0) {
          if (value) {
            this.bankDetails = value
            if (value.signFlag === 1) {
            //   this.isHxBank = value.crossFlag === '0' // 跨行标志, 0本行  1他行
            //   // 本行可直接输入资金密码+入金金额入金,他行需要转到指定银行卡号入金
            //   if (!this.isHxBank) {
            //     // 银行他行入金信息查询
            //     this.findBankInfo()
            //   }
            }
          }
          // 查询状态
        } else {
          this.$message(message)
        }
      })
    },
    // findBankInfo() {
    //   protocol51.param_showInFundInfo40.param.bankId = window.g.Bank_Id
    //   http.postFront(protocol51.param_showInFundInfo40).then(response => {
    //     const { code, message, value } = response.data
    //     if (code === 0 || code === '0') {
    //       this.bankDetails.bankAccountName = value.payeeName
    //       this.bankDetails.bankAccount = value.payeeCode
    //       this.bankDetails.openBankName = value.payeeBankName
    //     } else {
    //       this.$message(message)
    //     }
    //   })
    // },
    channelInputLimit(e) {
      const key = e.key
      // 不允许输入'e'
      if (key === 'e' || key === 'E') {
        e.returnValue = false
        return false
      }
      return true
    },
    changeAmount() {
      const numStr = /^(\d+)\.(\d{0,2}).*$/
      // 如果存在小数点的情况
      if (this.totalAmount.length >= 2) {
        if (String(this.totalAmount).indexOf('.') !== -1) {
          const dotNum = String(this.totalAmount).indexOf('.') + 1
          const firstNum = String(this.totalAmount).slice(0, 1)
          if (firstNum && dotNum > 2) {
          // 第一位是0且小数点边多个0
            this.totalAmount = this.totalAmount.replace(/\b(0+)/gi, '')
            this.totalAmount = this.totalAmount.replace(numStr, '$1.$2')
          } else {
            this.totalAmount = this.totalAmount.replace(numStr, '$1.$2')
          }
        } else {
        // 不存在小数点
          this.totalAmount = this.totalAmount.replace(/\b(0+)/gi, '')
        }
      }
    },
    changeWAmount() {
      let val = this.ruleForm.amount
      val = val.replace(/。/g, '.')
      val = val.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
      val = val.replace(/^\./g, '') // 验证第一个字符是数字
      val = val.replace(/\.{2,}/g, '') // 只保留第一个, 清除多余的
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两位小数
      val = val.replace(/^(?:0+(?=[1-9])|0+(?=0$))/mg, '')
      this.ruleForm.amount = val // 在进行赋值
    },
    getAllMoney() {
      // const newMargin = Number(this.canwithdraw)
      // this.ruleForm.amount = newMargin

      const newMargin = Number(this.moreMagin.split(',').join(''))
      this.ruleForm.amount = newMargin
    },
    changeType() {
      this.passType = this.passType == 'password' ? 'text' : 'password'
      this.passwordIcon =
        this.passType == 'password' ? this.closeImg : this.openImg
    },
    onCopy() {
      this.$message('复制成功')
    },
    onError() {
      this.$message('复制失败')
    },
    resetData() {
      this.selectData = ''
      this.typeCode = null
      this.tableData = []
      this.pageData = {
        total: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      }
      this.param_queryMyIntegralDetail()
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.param_queryMyIntegralDetail()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.param_queryMyIntegralDetail()
    },
    // 查询出入金流水
    param_queryMyIntegralDetail() {
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.bizCode =
        null
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.page =
        this.pageData.currentPage - 1
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.size =
        this.pageData.pageSize
      protocol.param_queryFirmBankAccountInoutFundsFlowFront.param.sort = [
        {
          direction: 'DESC', // "//DESC或ASC",
          property: 'occurTime' // "//排序属性"
        }
      ]
      http
        .postFrontChange(
          protocol.param_queryFirmBankAccountInoutFundsFlowFront,
          0
        )
        .then((response) => {
          const { code, value, message } = response.data
          if (Number(code) == '0') {
            this.pageData.total = value.totalElements
            const arr = value.content
            this.tableData = arr
          } else {
            this.$message(message)
          }
        })
    },
    searchFirmId1() {
      const userMes = this.$store.state.common.sessionInfo
      protocolTrans.param_firmIdSearch.param.userId = userMes.userId
      http.postFront(protocolTrans.param_firmIdSearch).then(response => {
        var { value, code, message } = response.data
        if (Number(code) === 0) {
          localStorage.setItem('FirmIdList_w', JSON.stringify(value))
          this.getMyAccount()
        } else {
          this.$message(message)
        }
      })
    },
    // 得到可出金额和上日权益
    getMyAccount() {
      var firmList = JSON.parse(localStorage.getItem('FirmIdList_w'))
      // const firmId = firmList.find(item => {
      //   return item.marketId === 0
      // }).firmId
      const firmId = firmList.map(item=>{
        return item.firmId
      })
      const param = JSON.parse(JSON.stringify(protocolTrans.param_mineAsset))
      // param.param.firmIds = [firmId]
      param.param.firmIds = firmId
      http.postFront(param).then((response) => {
        const { code, value, message } = response.data
        if (Number(code) == 0) {
          if (value) {
            // this.myAccount = value[0]
            console.log(123123, value);
            this.myAccount = value.find((item) => {
              return item.marketId === 0
            })
            // 计算期初之和
            this.marketslastbalance = 0
            value.map((item) => {
              this.marketslastbalance += item?.lastBalance ? Number(item.lastBalance) : 0
            })
            // 计算盈亏之和
            this.marketsLastHoldPl = 0
            value.map((item) => {
              this.marketsLastHoldPl += item?.lastHoldPl ? Number(item.lastHoldPl) : 0
            })
          }
        } else {
          this.$message(message)
        }
      })
    },
    // 入金提交
    // handleSubmitRj(name) {
    //   if (!this.totalAmount) {
    //     this.$message('请输入入金金额')
    //     return false
    //   }
    //   const reg = /^\d{6}$/
    //   if (Number(this.totalAmount) === 0) {
    //     return this.$message('入金金额不能为0，请重新输入')
    //   } else if (Number(this.totalAmount) < 0) {
    //     return this.$message('入金金额应大于0，请重新输入')
    //   } else if (!this.widthPwd) {
    //     this.$message('请输入资金密码')
    //     return false
    //   } else if (!reg.test(this.widthPwd)) {
    //     this.$message('请输入正确的资金密码')
    //     return false
    //   }
    //   protocol51.param_inFundOurBank.param.transAmt = this.totalAmount
    //   protocol51.param_inFundOurBank.param.pwd = md5(
    //     '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.widthPwd
    //   )
    //   const that = this
    //   this.btnDisenable1 = true
    //   this.loading1 = true
    //   http
    //     .postFrontMarket0(protocol51.param_inFundOurBank)
    //     .then((response) => {
    //       const { code, message } = response.data
    //       that.btnDisenable1 = false
    //       that.loading1 = false
    //       if (code === '0' || code === 0) {
    //         this.$message(message)
    //         this.totalAmount = ''
    //         this.widthPwd = null
    //         setTimeout(() => {
    //           that.param_queryMyIntegralDetail()
    //         }, window.g.Interface_latency_Time && 800)
    //         setTimeout(function() {
    //           that.getMyAccount()
    //         }, 3000)
    //         setTimeout(function() {
    //           that.getMyAccount()
    //         }, 6000)
    //         // window.location.href = value
    //       } else {
    //         this.$message(message)
    //       }
    //     })
    //     .catch((response) => {
    //       that.btnDisenable1 = false
    //       that.loading1 = false
    //     })
    // },
    // 出金提交
    handleSubmit(name) {
      const reg = /^\d{6}$/
      const regMoney = /^[0-9](\d+)?(\.\d{1,2})?$/
      if (!this.ruleForm.amount) {
        this.$message('请输入出金金额')
        return false
      } else if (!regMoney.test(this.ruleForm.amount)) {
        this.$message('请输入正确的出金金额')
        return false
      } else if (Number(this.ruleForm.amount) > Number(this.moreMagin)) {
        this.$message('超过可出金额')
        return false
      } else if (!this.ruleForm.password) {
        this.$message('请输入资金密码')
        return false
      } else if (!reg.test(this.ruleForm.password)) {
        this.$message('请输入正确的资金密码')
        return false
      }
      protocol51.param_outFund.param.pwd = md5(
        '47DEQpj8HBSa+/TImW+5JCeuQeRkm5NMpJWZG3hSuFU=' + this.ruleForm.password
      )
      protocol51.param_outFund.param.amount = Number(
        this.ruleForm.amount
      )
      const that = this
      this.btnDisenable = true
      this.loading = true
      http
        .postBankM0(protocol51.param_outFund)
        .then((response) => {
          const { code, message } = response.data
          that.btnDisenable = false
          that.loading = false
          if (code === '0' || code === 0) {
            this.$message('提交成功')
            this.ruleForm.password = ''
            this.ruleForm.amount = null
            setTimeout(() => {
              that.getMyAccount()
              that.param_queryMyIntegralDetail()
            }, window.g.Interface_latency_Time && 800)
          } else {
            this.$message(message)
          }
        })
        .catch((response) => {
          that.btnDisenable = false
          that.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#MyWithdraw {
  .centerContent {
    display: flex;
    margin: 20px 0;
    & > div {
      flex: 1;
    }
    .topTitle {
      padding-bottom: 20px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .topBanlance {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
      }
    }
    .desc {
      font-size: 14px;
      height: 60px;
      line-height: 60px;
      display: flex;
      justify-content: space-between;
      .tip {
        font-family: Source Han Sans SC;
        font-weight: 600;
        font-size: 12px;
        color: #D94066;
      }
      .title {
        font-family: Source Han Sans SC;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        width: 20%;
      }
      .el-input {
        width: 50%;
      }
      /deep/ input[type='number'] {
          text-indent: 0;
      }
      /deep/ .el-input__inner {
        height: 30px;
        border: 1px solid #C0C0C0;
      }
      /deep/ .el-input__suffix {
        height: 30px;
        line-height: 30px;
        top: 15px;
        right: 12px;
      }
      .btnWrap {
        width: 30%;
        text-align: left;
        padding-left: 22px;
        .el-button {
          width: 63px;
          height: 30px;
          border-radius: 30px;
          border: 0;
          background: #000;
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #ffffff;
          padding: 0;
        }
        .iconCopy {
          color: #D94066;
          cursor: pointer;
          display: inline-block;
        }
      }
    }
  }
  .flow {
    .headerWrap {
      height: 48px;
      line-height: 48px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      .leftText {
        font-family: Source Han Sans SC;
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
    }
  }
  .eyeStyle {
    width: 22px;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
